import { useQuery } from 'react-query';
import { request } from '../../../config/helpers/axios-instance';

const useActionNeededOrders = ({ page, size, failureCode, status, from, to }) =>
    useQuery(
        ['action-needed-orders', { page, size, failureCode, status, from, to }],
        () => {
            const params = { page, size };
            if (failureCode) params.failureCode = failureCode;
            if (status) params.status = status;
            if (from) params.from = from;
            if (to) params.to = to;
            return request({ url: 'userOrder/admin/actionNeeded', method: 'GET', params });
        },
        { keepPreviousData: true, refetchOnWindowFocus: false }
    );

export default useActionNeededOrders;
